const teinte = {
  primary: {
    uno: '#FF3633',
    due: '#FFF',
    tre: '#1F1F1F',
  },
  secondary: {
    uno: '#FF3B00', /* TODO: Replace with #AD0707 */
    due: '#F1F2F2', /* TODO: Replace with #A6AFBD */
    tre: '#DCE1E5',
  },
  tertiary: {
    uno: '#16ACE3', /* TODO: Replace with #0063BE */
    due: '#6DC6E7',
    tre: '#8DC63F', /* TODO: Replace with #00AE42 */
    quattro: '#9E1F63', /* TODO: Replace with #702785 */
    cinque: '#FF6418',
    sei: '#FFD200',
  },
};

export default teinte;
